import React from 'react';
import { StaticImageData } from 'next/image';

import { ArrowButtonProps } from 'Elements/Button/Arrow';

import Grid, { Col } from 'Components/Grid';

import {
    Container,
    ImageWrapper,
    StyledNextImage,
    InnerWrapper,
    Inner,
    Heading,
    Description,
    StyledArowButton
} from './ImageFade.styled';

export interface Props {
    id: string;
    heading: string;
    description: string;
    image: {
        src: StaticImageData | string;
        alt?: string;
    };
    link?: ArrowButtonProps;
    imageRight?: boolean;
}

const ImageFade: React.FC<Props> = props => {
    const { id, heading, description, image, link, imageRight } = props;

    return (
        <Container id={id} $imageRight={imageRight}>
            <ImageWrapper $imageRight={imageRight}>
                <StyledNextImage
                    src={image.src}
                    alt={image.alt ? image.alt : ''}
                    fill
                    $imageRight={imageRight}
                />
            </ImageWrapper>
            <Grid>
                <Col m={imageRight ? [1, 7] : [7, 13]} l={imageRight ? [1, 6] : [8, 13]}>
                    <InnerWrapper $imageRight={imageRight}>
                        <Inner $imageRight={imageRight}>
                            <Heading>{heading}</Heading>
                            <Description>{description}</Description>
                            {link && <StyledArowButton {...link} />}
                        </Inner>
                    </InnerWrapper>
                </Col>
            </Grid>
        </Container>
    );
};

export default ImageFade;
